<template>
    <el-dialog
            :title="title"
            :append-to-body="true"
            width="35%"
            @close="close"
            @open="open"
            :visible="show">
        <el-row style="margin: 5px 0">
            创建时间:
            <el-tag size="small">{{this.currentGroupBatch.created }}</el-tag>
        </el-row>
        <el-table :data="sizebatchgroupcraft_set" show-summary>
            <el-table-column width="150" prop="_shop_id" label="尺码"/>
            <el-table-column width="80" prop="_plan_num" label="分配数量"/>
            <el-table-column align="center" prop="finish_num" label="该批上报">
                <template slot-scope="scope">
                    <el-input-number
                            v-if="!groupFinish"
                            :min="0"
                            :max="scope.row._plan_num"
                            :step="1"
                            v-model="scope.row.finish_num"
                            size="mini">
                    </el-input-number>
                    <span v-else>{{ scope.row.finish_num }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin: 9px 5px">
            <el-button size="mini" :disabled="groupFinish" @click="updateBatch" :loading="updateLoading" type="primary">
                更 新
            </el-button>
            <el-button size="mini" :disabled="groupFinish" @click="deleteBatch" :loading="deleteLoading" type="danger">删
                除
            </el-button>
        </el-row>
        <span slot="footer">
                <el-button size="mini" @click="close">取 消</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        name: "GroupBatchDetail",
        data() {
            return {
                currentGroupBatchId: '',
                sizebatchgroupcraft_set: [],
                updateLoading: false,
                deleteLoading: false,
            }
        },
        computed: {
            url() {
                return `${this.$const.batchGroupUrl}${this.currentGroupBatch.id}/`
            },
            groupFinish() {
                return this.currentGroup.finish
            },
            ...mapState({
                title: 'GroupBatchDetailTitle',
                show: 'GroupBatchDetailShow',
                currentGroupBatch: 'currentGroupBatch',
                currentGroup: 'CurrentGroupCraft',
            })
        },
        methods: {
            /*
             * 关闭 dialog
             */
            close() {
                this.setGroupBatchDetailShow(false)
            },

            /*
             * 打开 dialog
             */
            open() {
                this.setGroupBatchDetailShow(true)
            },

            /*
             * 更新当前的 currentGroupBatch
             */
            updateBatch() {
                this.updateLoading = true
                const updateData = {
                    sizebatchgroupcraft_set: this.sizebatchgroupcraft_set
                }

                // 发送更新数据
                this.$patchRequest(this.url, updateData)
                    .then(response => {
                        this.updateLoading = false
                        this.handleResponse(response)
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '更新完成'
                        })
                    })
                    .catch(error => {
                        this.updateLoading = false
                    })
            },

            /*
             * 删除当前的 currentGroupBatch
             */
            deleteBatch() {
                this.deleteLoading = true
                this.$deleteRequest(this.url)
                    .then(response => {
                        this.deleteLoading = false
                        this.handleResponse(response)
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '删除批次成功'
                        })
                        this.close()
                    })
                    .catch(error => {
                        this.deleteLoading = false
                    })
            },

            /*
             * 处理操作[更新/删除] currentGroupBatch 的响应信息
             */
            handleResponse(response) {
                const craftRecord = response.data

                /*
                 * 更新 CurrentCraft 会驱动更新 currentGroup 与 currentGroupBatch
                 * 而 currentGroup 与 currentGroupBatch 的更新会驱动 initData 执行 ['刷新页面的效果']
                 */
                this.updateCurrentCraft(craftRecord)
            },

            /*
             * 初始化数据
             * 初始数据是根据 currentGroup 与 currentGroupBatch 计算出来的
             * 一旦 currentGroup 或 currentGroupBatch 发生变更
             * 则执行 init
             */
            initData() {
                this.currentGroupBatchId = this.currentGroupBatch.id
                this.sizebatchgroupcraft_set.length = 0  // clear

                // 将 mete(currentGroupBatch)  数据中的 id 转化为 完整数据的参考 Map
                const sizegroupcraftrecord_map = new Map()
                if (!this.currentGroup) {
                    return
                }

                if (this.currentGroup.sizegroupcraftrecord_set) {
                    this.currentGroup.sizegroupcraftrecord_set.forEach(sizeGroupCraftRecord => {
                        sizegroupcraftrecord_map.set(sizeGroupCraftRecord.id, sizeGroupCraftRecord)
                    })
                }


                if (this.currentGroupBatch.sizebatchgroupcraft_set) {
                    this.currentGroupBatch.sizebatchgroupcraft_set.forEach(sizeBatchGroupCraft => {
                        const detailSizeGroupCraftRecord = sizegroupcraftrecord_map.get(
                            sizeBatchGroupCraft.size_group_craft_record)

                        const initedSizeBatch = {
                            id: sizeBatchGroupCraft.id,
                            finish_num: sizeBatchGroupCraft.finish_num,      // 上报数据
                            _shop_id: detailSizeGroupCraftRecord.shop_id,    // 尺码
                            _plan_num: detailSizeGroupCraftRecord.plan_num,  // 该小组的该尺码的通知数量(也就是最大上报数量)
                        }

                        this.sizebatchgroupcraft_set.push(initedSizeBatch)
                    })
                }


            },
            ...mapMutations(['setGroupBatchDetailShow', 'updateCurrentCraft'])
        },
        watch: {
            currentGroupBatch() {
                this.initData()
            },
        },
        created() {
            this.initData()
        }
    }
</script>

<style scoped>

</style>